import { FinanceStats } from "../../actions/appExpandedActions/finances";

const initialState = {
  wallets: { docs: [], totalPages: 0 },
  transactions: { docs: [], totalPages: 0 },
  sharedWallets: { docs: [], totalPages: 0 },
  bankIntegrations: { docs: [], totalPages: 0 },
  financeStats: {},
};

const handleNewDocs = (state, payload, key) => {
  if (payload?.page === 1) return payload.docs;

  // ✅ Add safety check for state[key] and state[key].docs
  const existingDocs = state[key]?.docs || [];
  const newDocs = payload?.docs || [];

  const _docs = newDocs.filter(
    (newDoc) => !existingDocs.find((oldDoc) => newDoc._id === oldDoc._id)
  );

  return [...existingDocs, ..._docs];
};

const finances = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case FinanceStats.GET_FINANCE_AGGREGATED_STATS_SUCCESS:
      return {
        ...state,
        financeStats: payload,
      };

    case FinanceStats.GET_WALLETS_SUCCESS:
      return {
        ...state,
        wallets: {
          ...state.wallets,
          docs: handleNewDocs(state, payload, "wallets"),
          totalPages: payload.totalPages,
        },
      };

    case FinanceStats.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          docs: handleNewDocs(state, payload, "transactions"),
          totalPages: payload.totalPages,
        },
      };

    case FinanceStats.GET_SHARED_WALLETS_SUCCESS:
      return {
        ...state,
        sharedWallets: {
          ...state.sharedWallets,
          docs: handleNewDocs(state, payload, "sharedWallets"),
          totalPages: payload.totalPages,
        },
      };

    case FinanceStats.GET_BANK_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        bankIntegrations: {
          ...state.bankIntegrations,
          docs: handleNewDocs(state, payload, "bankIntegrations"),
          totalPages: payload.totalPages,
        },
      };

    default:
      return state;
  }
};

export default finances;